export const EVENTS_SCHEMA_VERSION = "0.58.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.28.0";
